/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum DoorstroomResultaat {
    DOORSTROOM = "Doorstroom",
    GESLAAGD = "Geslaagd",
    OPSTROOM = "Opstroom",
    AFSTROOM = "Afstroom",
    DOUBLURE = "Doublure",
    AFGEWEZEN = "Afgewezen",
    VO_VERLATER = "VO verlater",
    GEEN = "Geen"
}
